<template>
  <div :id="foodSelectWraperId" class="food-select-wraper">
    <div class="food-select-header">
      <a-tabs v-model="foodClassKey" type="card" @change="foodClassChange">
        <a-tab-pane
          v-for="item in foodClassList"
          :key="item.CategoryId"
          :tab="item.CategoryName"
        ></a-tab-pane>
        <div slot="tabBarExtraContent" style="margin-right:10px;">
          <span style="margin-right:10px;">
            显示估清
            <a-switch
              v-model="searchData.hasSoldOut"
              @change="onSearch"
            ></a-switch>
          </span>
          <a-input-search
            style="width:200px"
            v-model="searchData.keyword"
            placeholder="关键词查询"
            :allowClear="true"
            @change="onSearch"
          ></a-input-search>
        </div>
      </a-tabs>
    </div>
    <div class="food-select-list_wraper" :style="bodyStyle">
      <div
        class="food-select-list"
        :style="{ gridTemplateColumns: gridColumns }"
      >
        <div
          v-for="item in foodList"
          :key="item.DishId"
          :class="[
            `food-select-item`,
            { 'sold-out': item.IsSoldOut },
            { disabled: item.Status == 0 },
            { active: isChecked && selectedIds.includes(item.DishId) }
          ]"
          @click="onFoodClick(item)"
        >
          <div
            :class="[
              `food-item-title tc`,
              {
                'multi-line': item.DishName && item.DishName.length > 8
              }
            ]"
          >
            {{ item.DishName }}
          </div>
          <div class="flex">
            <div class="flex-item">
              <span>{{ item.UnitName }}</span>
            </div>
            <div
              style="font-size:12px;flex:2;line-height: 20px;"
              v-if="item.StockNum != null"
            >
              库存:<span style="color:#3c9c0c;margin-left:1px">{{
                item.StockNum
              }}</span>
            </div>
            <div class="flex-item tr rms-price">
              ￥{{
                isMemberOrder && item.MemberUnitPrice != null
                  ? item.MemberUnitPrice
                  : item.UnitPrice
              }}
              <span
                v-if="isMemberOrder && item.MemberUnitPrice != null"
                :class="{ 'is-member': isMemberOrder }"
                >会</span
              >
            </div>
          </div>
          <div class="right-button">
            <div
              v-if="item.IsPack"
              class="pack-button"
              @click.stop="showPackDetail(item)"
              title="点击查看明细"
            >
              套餐
            </div>
            <a-tooltip v-if="item.IsSoldOut">
              <template slot="title">
                {{ item.ForbiddenTime }}
              </template>
              <span class="soldout-button">禁</span>
            </a-tooltip>
          </div>
          <a-icon type="check-circle" class="has-checked" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { trimStr } from "@/utils/common";
import viewFoodPackModal from "../../maintenance/restaurant/viewFoodPackModal";

import "../rms.less";
import "../orderFood.less";

export default {
  props: {
    bodyStyle: {
      type: Object,
      default: () => {}
    },
    // 是否有选中状态
    isChecked: {
      type: Boolean,
      default: false
    },
    // 基础查询条件
    params: {
      type: Object,
      default: () => {}
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    //是否是会员点餐
    isMemberOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      foodList: [],
      foodClassKey: 0,
      foodClassList: [],
      searchData: {
        hasSoldOut: true,
        keyword: ""
      },
      // IsGiveStatus: false,
      foodSelectWraperWidth: "",
      foodSelectWraperId: "foodSelectWraper_" + Math.round(Math.random() * 100),
      selectedList: []
    };
  },
  computed: {
    gridColumns() {
      const num = Math.round(this.foodSelectWraperWidth / 130);
      let columns = "";
      for (let i = 0; i < num; i++) {
        columns = `${columns} 1fr`;
      }
      return columns;
    },
    selectedIds() {
      return this.selectedList.map(p => p.DishId);
    }
  },
  created() {
    this.init();
  },
  watch: {
    foodList(val) {
      this.$emit("getFoodList", val);
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.updateFoodSelectWraperWidth();
      })();
    };
    setTimeout(() => {
      this.updateFoodSelectWraperWidth();
    }, 10);
  },
  methods: {
    init() {
      this.selectedList = [];
      this.fetchFoodList();
    },
    // setGiveStatus(status) {
    //   this.IsGiveStatus = status;
    // },
    // getGiveStatus() {
    //   return this.IsGiveStatus;
    // },
    updateFoodSelectWraperWidth() {
      const foodSelectWraper = document.getElementById(this.foodSelectWraperId);
      if (foodSelectWraper) {
        this.foodSelectWraperWidth = foodSelectWraper.offsetWidth;
      }
    },
    foodClassChange(val) {
      const find = this.foodClassList.find(p => p.CategoryId === val);
      if (find && find.DishList) {
        this.foodList = find.DishList;
      }
    },
    fetchFoodList() {
      this.$post("RMS_GetDishList", { ...this.params }).then(res => {
        const data = res.Data;
        let allList = [];
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          allList = [...allList, ...item.DishList];
        }
        this.foodClassList = [
          {
            CategoryId: 0,
            CategoryName: "全部",
            DishList: allList
          },
          ...data
        ];
        if (this.foodClassKey) {
          const find = this.foodClassList.find(
            p => p.CategoryId === this.foodClassKey
          );
          if (find && find.DishList) {
            this.foodList = find.DishList;
          }
        } else {
          this.foodList = allList;
        }
        // this.foodList = allList;
      });
    },
    onSearch() {
      const { foodClassKey, foodClassList, searchData } = this;
      const find = foodClassList.find(p => p.CategoryId === foodClassKey);
      if (find && find.DishList) {
        const foodList = cloneDeep(find.DishList);
        this.foodList = foodList.filter(item => {
          if (!searchData.hasSoldOut && item.IsSoldOut) {
            // 不显示估清,且已售罄的
            return false;
          }
          let val = searchData.keyword;
          val = val ? trimStr(val).toUpperCase() : "";
          if (val && item.SimpleCode.indexOf(val) < 0) {
            // 关键词查询，且菜品名称不存在关键词的
            return false;
          }
          return true;
        });
      }
    },
    onFoodClick(item) {
      const { selectedList, selectedIds, multiple } = this;
      if (selectedIds.includes(item.DishId)) {
        this.selectedList = selectedList.filter(p => p.DishId != item.DishId);
      } else if (multiple) {
        this.selectedList.push(item);
      } else {
        this.selectedList = [item];
      }
      this.$emit("foodClick", item);
    },
    showPackDetail(item) {
      viewFoodPackModal({
        data: item.PackDetails
      });
    },
    getSelected() {
      return this.selectedList;
    },
    setSelected(keys) {
      this.selectedList = keys;
    }
  }
};
</script>
